import React from 'react';
import {
  TableCard,
  Box,
} from 'vindi-ds-components';

function TableCardChargesPending({ listingData }) {
  return (
    <Box display='flex' flexDirection='column' gridGap='24px' mb={2}>
      {listingData?.chargesPending?.map((charge) => (
        <TableCard.Container key={charge.id}>
          <TableCard.TextWithAction label='Nome' value={charge.customer_name} />
          <TableCard.Text label='Valor' value={charge.amount} />
          <TableCard.Text label='Emissão' value={charge.created_at} />
          <TableCard.Text label='Vencimento' value={charge.due_at} />
          <TableCard.TextWithTagChip label='Notificações' value={charge.notification} kind='attention' />
          <TableCard.Text label='Última visualização' value={charge.seen_at || '-'} />
        </TableCard.Container>
      ))}
    </Box>
  );
}

export default TableCardChargesPending;
